import React from 'react'
import { Helmet } from 'react-helmet'
import Home from '../../components/Home'

const HomePage = () => {
  return (
    <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>  جان اسنک بزرگترین برند زنجیره ای اسنک در ایران | جان اسنک</title>
        </Helmet>
        <Home/>
    </>
  )
}

export default HomePage